// /robots.txt — refus blanket pour tous les user-agents. Combiné avec les
// meta robots du layout, c'est de la défense en profondeur : un crawler bien
// élevé voit le robots.txt et n'essaie même pas, un crawler malicieux voit le
// noindex sur la page (et de toute façon l'IP allowlist le bloque avant).

import type { MetadataRoute } from "next";

export default function robots(): MetadataRoute.Robots {
  return {
    rules: [{ userAgent: "*", disallow: "/" }],
  };
}
